<template>
  <v-app id="app">
    <LoadingOverlayCircular v-if="isLoadingCircular"></LoadingOverlayCircular>

    <!-- ヘッダー -->
    <Header v-if="isShowHeader" />

    <!-- コンテンツ -->
    <v-content id="top_card" class="content">
      <CommonMessage />
      <BackTopButton />
      <transition name="router-transition">
        <router-view></router-view>
      </transition>
    </v-content>
    <!-- フッター -->
    <Footer v-if="isLoginPage || isDefaultPage" />
    <EinsteinBotImport v-if="isShowChat" />
  </v-app>
</template>

<script>
import 'normalize.css';
import BackTopButton from '@/components/_atoms/buttons/BackTopButton.vue';
import LoadingOverlayCircular from '@/components/_atoms/loadings/LoadingOverlayCircular.vue';
import CommonMessage from '@/components/_organisms/CommonMessage.vue';
import Header from '@/components/_organisms/Header.vue';
import Footer from '@/components/_organisms/Footer.vue';
import EinsteinBotImport from '@/components/_organisms/EinsteinBotImport.vue';

export default {
  name: 'App',
  computed: {
    isLoggedIn: function() {
      return this.$store.state.auth.isLoggedIn;
    },
    isLoginPage: function() {
      return this.$route.name === 'Login' || this.$route.name === 'LoginForCloudsignReview';
    },
    isShowHeader: function() {
      return this.$store.state.showHeader.isShowHeader;
    },
    isDefaultPage: function() {
      return this.$route.name === 'PageNotFound';
    },
    isLoadingCircular: function() {
      return this.$store.state.loading.isLoadingCircular;
    },
    isSalesforceUserLinked: function() {
      return this.$store.state.auth.profile.isSalesforceUserLinked;
    },
    canUseChatBot: function() {
      return this.$store.state.auth.profile.canUseChatBot;
    },
    isShowChat: function() {
      return this.isLoggedIn && this.isSalesforceUserLinked && this.canUseChatBot;
    }
  },
  beforeCreate() {
    this.$store.dispatch('userAgent/setData');
  },
  mounted() {
    if (this.$route.name === 'LoginForCloudsignReview') {
      this.changeMetaInfo();
    }
    if (this.isLoggedIn) {
      if (this.$store.state.auth.isDispPoweredLabel) {
        this.changeMetaInfo();
      }
    }
  },
  components: {
    EinsteinBotImport,
    CommonMessage,
    LoadingOverlayCircular,
    BackTopButton,
    Header,
    Footer
  },
  methods: {
    changeMetaInfo() {
      document.title = 'cloudsign review';
      const link = document.querySelector("link[rel*='icon']");
      link.href = 'static/favicon-cloudsign-review.ico';
    }
  }
};
</script>

<style scoped>
.content {
  background: #f1f2f6;
  margin-top: 50px;
}
.progresbar {
  z-index: 130;
}
.app__circular {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1000;
}
.overlay--active::before {
  opacity: 0.46;
  background-color: #212121;
  content: '';
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  -webkit-transition: inherit;
  transition: inherit;
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
  z-index: 900;
}
</style>



// WEBPACK FOOTER //
// src/App.vue